export default __webpack_public_path__ + "static/media/twenty-one_demo_image.16bfdab5.png";